import React from 'react';
import { MarketOpportunity } from '../components/MarketOpportunity';
import { BusinessModel } from '../components/BusinessModel';
import { GrowthRoadmap } from '../components/GrowthRoadmap';
import { FundraiseSection } from '../components/FundraiseSection';
import { LeadershipSection } from '../components/LeadershipSection';
import { TractionSection } from '../components/TractionSection';
import { VisionSection } from '../components/VisionSection';
import { SiteFooter } from '../components/ui/SiteFooter';
export function InvestorsPage() {
  return <main className="min-h-screen bg-ivory font-sans text-charcoal selection:bg-purple-200 selection:text-charcoal" data-id="element-539" data-mp="1ak9aq1acb7l5">
      {/* Navigation */}
      <nav className="sticky top-0 left-0 right-0 z-50 px-6 py-6 flex justify-between items-center max-w-7xl mx-auto bg-ivory/95 backdrop-blur-sm border-b border-charcoal/5" data-id="element-540" data-mp="11le6uvurq9l0">
        <a href="/" data-id="element-541" data-mp="wnm7xhvphn7b">
          <img src="https://cdn.magicpatterns.com/uploads/xpYure8muF9bisffxXgVg2/fementity.png" alt="Fem Entity" className="h-8 md:h-10" data-id="element-542" data-mp="rm6jdfubkyk6" />
        </a>
        <div className="hidden md:flex space-x-8 text-sm font-medium text-charcoal/80" data-id="element-543" data-mp="2exmdsh2t1sx7">
          <a href="/" className="hover:text-purple-700 transition-colors" data-id="element-544" data-mp="208zts228gczn">
            Home
          </a>
          <a href="/get-the-app" className="hover:text-purple-700 transition-colors" data-id="element-545" data-mp="257t98012ye2g">
            Download the App
          </a>
          <a href="/practitioners" className="hover:text-purple-700 transition-colors" data-id="element-546" data-mp="2svknh966l16d">
            Practitioners
          </a>
        </div>
      </nav>

      {/* Hero Section for Investors */}
      <section className="relative min-h-[60vh] flex items-center justify-center overflow-hidden bg-ivory pt-20 pb-20" data-id="element-547" data-mp="2nyaph54q7h6x">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-purple-200/30 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-breathe" data-id="element-548" data-mp="17k1bn4y41auc"></div>
        <div className="absolute bottom-1/4 right-1/4 w-[30rem] h-[30rem] bg-purple-200/40 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-breathe" style={{
        animationDelay: '2s'
      }} data-id="element-549" data-mp="1ch17yo55qz89"></div>

        <div className="max-w-5xl mx-auto px-6 relative z-10 text-center" data-id="element-550" data-mp="35eyewwv8u2nr">
          <div className="inline-flex items-center space-x-2 px-4 py-2 rounded-full border border-purple-200/60 bg-white/30 backdrop-blur-sm mb-8" data-id="element-551" data-mp="30hy8ulye8zwn">
            <span className="text-sm font-medium tracking-wide uppercase text-charcoal/80" data-id="element-552" data-mp="2vfz3x7n09uxl">
              Investment Opportunity
            </span>
          </div>

          <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif text-charcoal leading-[1.1] mb-8 tracking-tight" data-id="element-553" data-mp="2migd1mmokmds">
            Building the Future of{' '}
            <span className="italic text-charcoal/80" data-id="element-554" data-mp="kq0jkwav4o4z">Women's Wellness</span>
          </h1>

          <p className="text-lg md:text-xl text-charcoal/70 max-w-3xl mx-auto mb-12 font-light leading-relaxed" data-id="element-555" data-mp="kno3ypskupv3">
            Join us in creating a new category of care — where technology,
            community, and trusted practitioners converge to serve the most
            underserved market in healthcare.
          </p>
        </div>
      </section>

      {/* Investor-focused sections */}
      <MarketOpportunity data-id="element-556" data-mp="x2m7g6uc3d92" />
      <BusinessModel data-id="element-557" data-mp="11zw4o8nyst7g" />
      <TractionSection data-id="element-558" data-mp="11ybbamddzgb6" />
      <GrowthRoadmap data-id="element-559" data-mp="11yl22c699rhx" />
      <VisionSection data-id="element-560" data-mp="12177a55obuwz" />
      <LeadershipSection data-id="element-561" data-mp="4buhhr3v3ku6" />
      <FundraiseSection data-id="element-562" data-mp="4cnp0uanaedd" />

      <SiteFooter currentPath="/investors" data-id="element-563" data-mp="4df7r4j58hm8" />
    </main>;
}